import { Link, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useServiceDeskLink } from '@/components/Common/SupportLink/createServiceDeskLink';
import { useSelectedAccountId } from '@/routes/_authenticated/_dashboard/accounts/$accountId/route.hooks';
import { QUOTA_INCREASE_DESCRIPTION } from '../Account/constants';

export const DashboardAccountCreationInsufficientQuota = memo(function DashboardAccountCreationInsufficientQuota({
  value,
  quota,
}: {
  value: number;
  quota: number;
}) {
  const accountId = useSelectedAccountId();
  const url = useServiceDeskLink({
    summary: 'Quota increase request',
    description: QUOTA_INCREASE_DESCRIPTION,
    accountId,
  });

  return (
    <Stack
      sx={{
        alignItems: 'center',
        bgcolor: 'background.paper',
        borderRadius: 1,
        color: 'text.secondary',
        gap: 1,
        px: 2,
        py: 1,
      }}
    >
      <Typography variant="caption">
        Account Limit reached ({value}/{quota}).{' '}
        <Link href={url} target="_blank" rel="noreferrer">
          Get more
        </Link>
      </Typography>
    </Stack>
  );
});
